export default __webpack_public_path__ + "static/media/Pilgrimage.e8300ff1.svg";